import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "../store"

export const isLoading = (state: RootState) => state.loadingSlice.isLoading

export const selectIsLoading = createSelector([isLoading], isLoading => ({
  isLoading,
}))
